import { DriverEntity } from 'backend-entity';

export type MobileBffGetRentDriversResponse = {
  rows: Omit<DriverEntity, 'profile'>[];
  total: number;
};
